var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("出库管理")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("添加内部出库")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "basic" },
        [
          _c("p", { staticClass: "header" }, [_vm._v("基本信息")]),
          _c(
            "el-form",
            {
              ref: "basic",
              attrs: {
                inline: true,
                model: _vm.basic,
                rules: _vm.rules,
                "label-width": "80px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "收货人", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入收货人姓名" },
                    model: {
                      value: _vm.basic.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.basic, "name", $$v)
                      },
                      expression: "basic.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系电话", prop: "phone" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入联系电话" },
                    model: {
                      value: _vm.basic.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.basic, "phone", $$v)
                      },
                      expression: "basic.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "部门选择", prop: "orgName" } },
                [
                  _c(
                    "div",
                    { staticClass: "selectTree" },
                    [
                      _c("treeselect", {
                        attrs: {
                          options: _vm.optionsTeam,
                          "search-nested": "",
                          normalizer: _vm.normalizer,
                          noResultsText: "未找到",
                          placeholder: "请选择",
                        },
                        model: {
                          value: _vm.basic.orgName,
                          callback: function ($$v) {
                            _vm.$set(_vm.basic, "orgName", $$v)
                          },
                          expression: "basic.orgName",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "出库类型", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择出库类型",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.basic.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.basic, "type", $$v)
                        },
                        expression: "basic.type",
                      },
                    },
                    _vm._l(_vm.outboundTypes, function (items) {
                      return _c("el-option", {
                        key: items.id,
                        attrs: { label: items.deliveryName, value: items.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "地区", required: "" } },
                [
                  _c("levelAddr", {
                    staticClass: "addressContent",
                    attrs: {
                      province: _vm.basic.province,
                      city: _vm.basic.city,
                      area: _vm.basic.area,
                    },
                    on: {
                      updateprovice: _vm.getAddrData,
                      updatecity: _vm.getCity,
                      updatearea: _vm.getArea,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "详细地址", prop: "detail" } },
                [
                  _c(
                    "div",
                    { staticClass: "length" },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入详细地址" },
                        model: {
                          value: _vm.basic.detail,
                          callback: function ($$v) {
                            _vm.$set(_vm.basic, "detail", $$v)
                          },
                          expression: "basic.detail",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.getClickTabList },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "选择商品", name: "1" } }, [
                _c("div", { staticClass: "selectGoods" }, [
                  _c(
                    "div",
                    { staticClass: "search" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "address",
                          attrs: {
                            inline: true,
                            model: _vm.goods,
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "产品名称" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入产品名称" },
                                model: {
                                  value: _vm.goods.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.goods, "name", $$v)
                                  },
                                  expression: "goods.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "产品编号" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入产品编号" },
                                model: {
                                  value: _vm.goods.goodsNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.goods, "goodsNo", $$v)
                                  },
                                  expression: "goods.goodsNo",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "选择品牌" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择产品品牌",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.goods.brand,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.goods, "brand", $$v)
                                    },
                                    expression: "goods.brand",
                                  },
                                },
                                _vm._l(_vm.brandselect, function (items) {
                                  return _c("el-option", {
                                    key: items.id,
                                    attrs: {
                                      label: items.name,
                                      value: items.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "品牌分类" } },
                            [
                              _c("el-cascader", {
                                attrs: {
                                  options: _vm.options,
                                  props: {
                                    checkStrictly: true,
                                    label: "name",
                                    value: "id",
                                    children: "children",
                                  },
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.goods.category,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.goods, "category", $$v)
                                  },
                                  expression: "goods.category",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "mini" },
                                  on: { click: _vm.searchGoods },
                                },
                                [_vm._v("搜索商品")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { plain: "", size: "mini" },
                                  on: { click: _vm.reset },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "list" },
                    [
                      _c(
                        "vxe-table",
                        {
                          attrs: {
                            data: _vm.goodsL.list,
                            height: "500px",
                            align: "center",
                            "auto-resize": "",
                          },
                        },
                        [
                          _c("vxe-table-column", {
                            attrs: { type: "seq", title: "序号", width: "50" },
                          }),
                          _c("vxe-table-column", {
                            attrs: {
                              field: "name",
                              title: "商品名称",
                              "show-overflow": "",
                              "min-width": "200",
                            },
                          }),
                          _c("vxe-table-column", {
                            attrs: {
                              field: "goodsNo",
                              title: "商品编号",
                              "min-width": "100",
                            },
                          }),
                          _c("vxe-table-column", {
                            attrs: {
                              field: "brandName",
                              title: "商品品牌",
                              "min-width": "100",
                            },
                          }),
                          _c("vxe-table-column", {
                            attrs: {
                              field: "categoryName",
                              title: "商品分类",
                              "min-width": "100",
                            },
                          }),
                          _c("vxe-table-column", {
                            attrs: {
                              field: "marketPrice",
                              title: "商品单价",
                              "min-width": "100",
                            },
                          }),
                          _c("vxe-table-column", {
                            attrs: {
                              field: "specification",
                              title: "商品规格",
                              "min-width": "100",
                            },
                          }),
                          _c("vxe-table-column", {
                            attrs: {
                              field: "stock",
                              title: "商品库存",
                              "min-width": "100",
                            },
                          }),
                          _c("vxe-table-column", {
                            attrs: {
                              fixed: "right",
                              title: "操作",
                              width: "120px",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.moreCombination(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("添加商品")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "page" }, [
                  _c(
                    "div",
                    {
                      staticClass: "block",
                      staticStyle: { "padding-right": "40px" },
                    },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.currentPage1,
                          "page-sizes": [10, 20, 50, 100, 200],
                          "page-size": _vm.pageSizegoods,
                          layout: "total, sizes, prev, pager, next, jumper",
                          total: _vm.goodsL.totalNum,
                          "prev-text": "上一页",
                          "next-text": "下一页",
                        },
                        on: {
                          "size-change": _vm.handleSizeChange,
                          "current-change": _vm.handleCurrentChange,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("el-tab-pane", { attrs: { label: "选择赠品", name: "3" } }, [
                _c("div", { staticClass: "specify" }, [
                  _c(
                    "div",
                    { staticClass: "search" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "address",
                          attrs: {
                            inline: true,
                            model: _vm.goods,
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "产品名称" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入产品名称" },
                                model: {
                                  value: _vm.goods.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.goods, "name", $$v)
                                  },
                                  expression: "goods.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "产品编号" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入产品编号" },
                                model: {
                                  value: _vm.goods.goodsNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.goods, "goodsNo", $$v)
                                  },
                                  expression: "goods.goodsNo",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "选择品牌" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择产品品牌",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.goods.brand,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.goods, "brand", $$v)
                                    },
                                    expression: "goods.brand",
                                  },
                                },
                                _vm._l(_vm.brandselect, function (items) {
                                  return _c("el-option", {
                                    key: items.id,
                                    attrs: {
                                      label: items.name,
                                      value: items.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "品牌分类" } },
                            [
                              _c("el-cascader", {
                                attrs: {
                                  options: _vm.options,
                                  props: {
                                    checkStrictly: true,
                                    label: "name",
                                    value: "id",
                                    children: "children",
                                  },
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.goods.category,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.goods, "category", $$v)
                                  },
                                  expression: "goods.category",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.searhgift()
                                    },
                                  },
                                },
                                [_vm._v("搜索赠品")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.reset()
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "list" },
                    [
                      _c(
                        "vxe-table",
                        {
                          attrs: {
                            data: _vm.giftL.list,
                            height: "500px",
                            "auto-resize": "",
                            align: "center",
                          },
                        },
                        [
                          _c("vxe-table-column", {
                            attrs: { type: "seq", title: "序号", width: "100" },
                          }),
                          _c("vxe-table-column", {
                            attrs: {
                              field: "name",
                              title: "赠品名称",
                              "min-width": "300",
                              "show-overflow": "",
                            },
                          }),
                          _c("vxe-table-column", {
                            attrs: {
                              field: "goodsNo",
                              title: "赠品编号",
                              "min-width": "120",
                            },
                          }),
                          _c("vxe-table-column", {
                            attrs: {
                              field: "brandName",
                              title: "赠品品牌",
                              "min-width": "120",
                            },
                          }),
                          _c("vxe-table-column", {
                            attrs: {
                              field: "categoryName",
                              title: "赠品分类",
                              "min-width": "120",
                            },
                          }),
                          _c("vxe-table-column", {
                            attrs: {
                              field: "marketPrice",
                              title: "赠品单价",
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c("p", [
                                      _vm._v(
                                        " " +
                                          _vm._s("￥" + props.row.marketPrice) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("vxe-table-column", {
                            attrs: {
                              field: "specification",
                              title: "赠品规格",
                              "min-width": "120",
                            },
                          }),
                          _c("vxe-table-column", {
                            attrs: {
                              field: "stock",
                              title: "赠品库存",
                              "min-width": "120",
                            },
                          }),
                          _c("vxe-table-column", {
                            attrs: {
                              fixed: "right",
                              title: "操作",
                              "min-width": "120px",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.moreCombination(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("添加赠品")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "page" }, [
                  _c(
                    "div",
                    {
                      staticClass: "block",
                      staticStyle: { "padding-right": "40px" },
                    },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.currentPage1,
                          "page-sizes": [10, 20, 50, 100, 200],
                          "page-size": _vm.pageSizegoods,
                          layout: "total, sizes, prev, pager, next, jumper",
                          total: _vm.giftL.totalNum,
                        },
                        on: {
                          "size-change": _vm.handleSizeChangeZp,
                          "current-change": _vm.handleChangeZp,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "orderBox" }, [
        _c(
          "div",
          { staticClass: "order" },
          [
            _c(
              "p",
              {
                staticClass: "header",
                staticStyle: { background: "#fff", padding: "10px" },
              },
              [_vm._v("订单商品")]
            ),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.orderDetailList },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "商品名称" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _vm._v(_vm._s(scope.row.title || scope.row.name)),
                            scope.row.goodsType == "赠品"
                              ? _c("span", { staticClass: "gift" }, [
                                  _vm._v("赠品"),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "商品数量" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "p",
                            {
                              staticClass: "table-price",
                              staticStyle: { "text-align": "center" },
                            },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  size: "mini",
                                  min: 1,
                                  label: "描述文字",
                                },
                                model: {
                                  value: scope.row.quantity,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "quantity", $$v)
                                  },
                                  expression: "scope.row.quantity",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "商品单价" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "sellPrice" },
                            [
                              _c("el-input", {
                                attrs: { value: scope.row.retailPrice },
                                on: {
                                  change: function ($event) {
                                    return _vm.changePrice(
                                      scope.row,
                                      scope.$index
                                    )
                                  },
                                },
                                model: {
                                  value: scope.row.retailPrice,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "retailPrice", $$v)
                                  },
                                  expression: "scope.row.retailPrice",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "商品品牌" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.brandName
                            ? _c("span", [_vm._v(_vm._s(scope.row.brandName))])
                            : _c("span", [_vm._v(" / ")]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "商品分类" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.categoryName
                            ? _c("span", [
                                _vm._v(_vm._s(scope.row.categoryName)),
                              ])
                            : _c("span", [_vm._v(" / ")]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "商品规格" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.specTitle
                            ? _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(scope.row.specTitle),
                                },
                              })
                            : _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(scope.row.specification),
                                },
                              }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "total", label: "商品小计" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                parseFloat(
                                  scope.row.quantity * scope.row.retailPrice
                                ).toFixed(2)
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { "min-width": "50px", fixed: "right", label: "操作" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.delectSelect(scope.$index)
                                },
                              },
                            },
                            [_vm._v("删除商品")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("div", { staticClass: "page1" }, [
              _c("p", [
                _c("span", [
                  _vm._v("总计：共 " + _vm._s(_vm.totalNumber) + " 件 "),
                ]),
              ]),
              _c(
                "p",
                [
                  _c("span", [_vm._v("总价:")]),
                  _c("el-input", {
                    attrs: { size: "mini", placeholder: "" },
                    model: {
                      value: _vm.totalPrice,
                      callback: function ($$v) {
                        _vm.totalPrice = $$v
                      },
                      expression: "totalPrice",
                    },
                  }),
                ],
                1
              ),
              _c(
                "p",
                [
                  _c("span", [_vm._v("已收款:")]),
                  _c("el-input-number", {
                    staticStyle: { width: "120px" },
                    attrs: {
                      controls: false,
                      precision: 2,
                      size: "mini",
                      placeholder: "",
                    },
                    on: { blur: _vm.handlerReceivedMoney },
                    model: {
                      value: _vm.receivedMoney,
                      callback: function ($$v) {
                        _vm.receivedMoney =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "receivedMoney",
                    },
                  }),
                ],
                1
              ),
              _c(
                "p",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.toReviewOrder("basic")
                        },
                      },
                    },
                    [_vm._v("确定订单")]
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "orderNotes" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "notes" },
          [
            _c("el-input", {
              attrs: { type: "textarea", placeholder: "备注" },
              model: {
                value: _vm.basic.textarea,
                callback: function ($$v) {
                  _vm.$set(_vm.basic, "textarea", $$v)
                },
                expression: "basic.textarea",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            "append-to-body": "",
            width: _vm.dialog.width,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          [
            _vm._l(_vm.specList, function (item, index) {
              return _c("div", { key: index, staticClass: "skuBox" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(item.name)),
                ]),
                _c(
                  "div",
                  { staticClass: "spec" },
                  _vm._l(item.specItemList, function (its, ins) {
                    return _c(
                      "div",
                      { key: its.content + ins, staticClass: "spec-item" },
                      [
                        _c(
                          "span",
                          {
                            class: [
                              _vm.selectSpec[item.name] == its.content
                                ? "active"
                                : "",
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.changeSpec(item.name, its.content)
                              },
                            },
                          },
                          [_vm._v(_vm._s(its.content))]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            }),
            _c("div", { staticClass: "specificationBox" }, [
              _c("p", { staticClass: "specificationBox_title" }, [
                _c("span", { staticClass: "specificationBox_title_item" }, [
                  _vm._v("已选规格："),
                ]),
                _c("span", { staticClass: "specificationBox_title_right" }, [
                  _vm.matchingStr == ""
                    ? _c("b", [_vm._v("未选择")])
                    : _c("b", {
                        domProps: { innerHTML: _vm._s(_vm.matchingStr) },
                      }),
                ]),
              ]),
              _c("div", { staticClass: "specificationBox_border" }, [
                _c("div", { staticClass: "specificationBox_border_item" }, [
                  _c("span", { staticClass: "item" }, [_vm._v("市场价")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "item" }, [_vm._v("零售价")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "item" }, [_vm._v("销量")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "item" }, [_vm._v("库存")]),
                ]),
                _c("div", { staticClass: "specificationBox_border_money" }, [
                  _c("span", { staticClass: "item" }, [
                    _vm._v(
                      _vm._s(
                        _vm.matching.marketPrice
                          ? "￥" + _vm.matching.marketPrice
                          : "-"
                      )
                    ),
                  ]),
                  _c("span", { staticClass: "item" }, [
                    _vm._v(
                      _vm._s(
                        _vm.matching.retailPrice
                          ? "￥" + _vm.matching.retailPrice
                          : "-"
                      )
                    ),
                  ]),
                  _c("span", { staticClass: "item" }, [
                    _vm._v(
                      _vm._s(
                        _vm.matching.soldNum || _vm.matching.soldNum === 0
                          ? _vm.matching.soldNum
                          : "-"
                      )
                    ),
                  ]),
                  _c("span", { staticClass: "item" }, [
                    _vm._v(
                      _vm._s(_vm.matching.stock ? _vm.matching.stock : "-")
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "dialogBtnright",
                staticStyle: { "margin-top": "20px" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "setPay_payment_btn_quxiao",
                    on: { click: _vm.handledeleteClose },
                  },
                  [_vm._v("取 消")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "setPay_payment_btn_queren",
                    attrs: { type: "primary" },
                    on: { click: _vm.addSelectList },
                  },
                  [_vm._v("确 定")]
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("span", [_vm._v("订单备注")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }